module.exports = __webpack_public_path__ + "img/other-service-blue.68727ea2.svg";